import React from 'react'
import Grid from '@mui/material/Grid'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

const ImmobilisationDevice = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <Autocomplete
      multiple
      freeSolo
      options={[
        'Cervical Collar',
        'Backboard',
        'Scoop Stretcher',
        'KED',
        'Spinal Immobilizer',
      ]}
      label="Immobilisation Device"
      value={moduleValues?.['Immobilisation Device'] ?? []}
      onChange={(e, value) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Immobilisation Device']: value,
        }))
      }
      renderInput={(params) => (
        <TextField {...params} fullWidth label="Immobilisation Device" />
      )}
    />
  </Grid>
)

export default ImmobilisationDevice
